import { PlatePluginComponent, TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { DreamBlock } from '@typedream/core';
import { FormElement } from './components/Form';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_FORM } from '../../pluginKeys';
import { FormPluginOptions } from './types';
import { withDropTarget } from '../../plugins/dnd';

export const createFormPlugin = createTElementPluginFactory({
  key: ELEMENT_FORM,
  component: withDropTarget(FormElement as ComponentType<TRenderElementProps>),
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: {
      dimensionIndicator: true,
    },
    isDraggable: true,
    isDroppable: false,
    meta: {
      img: '/images/form.png',
      title: 'Form',
      subtitle: 'Collect data from your users using form',
      keywords: ['form', 'submission'],
    },
    format: {
      formatType: 'block',
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['width', 'width_max', 'height', 'mobile_hide', 'desktop_hide', 'background', 'align', 'vertical_align', 'form_id', 'connect_data'],
    },
    getFormContent: () => {
      throw Error("You need to override 'getFormContent' option");
    },
  },
} as {
  key: DreamBlock['type'],
  component: PlatePluginComponent,
  options: FormPluginOptions;
});
